module.exports = __webpack_public_path__ + "files/5f4dba2230c0cf4a101c8ffb1dfab816.png";